import { defineMessages } from 'react-intl';

export default defineMessages({
    ambulanceService: {
        id: 'claim.views.landing-page.ADAC Ambulance service',
        defaultMessage: 'ADAC Ambulance service'
    },
    urgentHelp: {
        id: 'claim.views.landing-page.I need urgent help abroad',
        defaultMessage: 'I need urgent help abroad'
    },
    travelCountryMedicalCareInfo: {
        id: 'claim.views.landing-page.I have questions about medical care in my travel country',
        defaultMessage: 'I have questions about medical care in my travel country'
    },
    destinationCountryMedicalCareInfo: {
        id: 'claim.views.landing-page.I need medical information before a trip',
        defaultMessage: 'I need medical information before a trip'
    },
    howCanWeHelp: {
        id: 'claim.views.landing-page.How can we help you?',
        defaultMessage: 'How can we help you?'
    },
    acceptPrivacyPolicy: {
        id: 'claim.views.landing-page.Accept privacy policy',
        defaultMessage: 'Accept privacy policy'
    },
    furtherStepsConsent: {
        id: 'claim.views.landing-page.Further steps consent',
        defaultMessage: 'In the further steps we need personal data in order to process your request quickly. For this we need your consent to our data { dataProtection } & { termsOfUse }.'
    },
    dataProtection: {
        id: 'claim.views.landing-page.protection declaration',
        defaultMessage: 'protection declaration and terms of use'
    },
    termsOfUse: {
        id: 'claim.views.landing-page.terms of use',
        defaultMessage: 'terms of use'
    },
    dataProtectionLink: {
        id: 'claim.views.landing-page.Data protection link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/'
    },
    termsOfUseLink: {
        id: 'claim.views.landing-page.Terms of use link',
        defaultMessage: 'https://www.adac.de/datenschutz-dsgvo/ambulance-app/nutzungsbedingungen/'
    },
    next: {
        id: 'claim.views.landing-page.Next',
        defaultMessage: 'Next'
    }
});
